<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 800px; max-width: 90vw;">
      <q-card-section class="row items-center">
        <div class="text-h6">
          Unallocated {{ unallocatedType }} Switchboards
        </div>
        <q-space />
        <q-badge :color="badgeColor" text-color="white">
          {{ itemCount }} items
        </q-badge>
        <q-btn icon="close" flat round dense @click="$emit('update:modelValue', false)" />
      </q-card-section>

      <q-card-section>
        <q-input
          :model-value="filterText"
          placeholder="Search switchboards..."
          dense
          outlined
          class="q-mb-md"
          @update:model-value="$emit('update:filter', $event)"
        >
          <template #append>
            <q-icon name="search" />
          </template>
        </q-input>

        <q-list separator>
          <q-item
            v-for="switchboard in filteredList"
            :key="switchboard.id"
            clickable
          >
            <q-item-section avatar>
              <q-icon
                :name="switchboard.icon"
                :color="switchboard.color"
                size="md"
              />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ switchboard.name }}</q-item-label>
              <q-item-label caption>
                {{ switchboard.location }}
              </q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-btn
                size="sm"
                color="primary"
                label="Add to Tree"
                :disable="!switchboard.canAdd"
                @click="$emit('quick-add', switchboard)"
              >
                <q-tooltip v-if="!switchboard.canAdd">
                  Select a compatible parent node first
                </q-tooltip>
              </q-btn>
            </q-item-section>
          </q-item>

          <q-item v-if="filteredList.length === 0">
            <q-item-section class="text-center text-grey-6">
              No unallocated {{ unallocatedType }} switchboards found
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';

  const props = defineProps({
    modelValue: { type: Boolean, required: true },
    unallocatedType: { type: String, required: true },
    badgeColor: { type: String, default: 'primary' },
    itemCount: { type: Number, default: 0 },
    filterText: { type: String, default: '' },
    filteredList: { type: Array, required: true },
  });

  const emit = defineEmits(['update:modelValue', 'update:filter', 'quick-add']);
</script>
